// Caltrans county codes
const ctCountyOptions = [
  { value: "Ala", label: "Ala - Alameda" },
  { value: "Alp", label: "Alp - Alpine" },
  { value: "Ama", label: "Ama - Amador" },
  { value: "But", label: "But - Butte" },
  { value: "Cal", label: "Cal - Calaveras" },
  { value: "Col", label: "Col - Colusa" },
  { value: "CC", label: "CC - Contra Costa" },
  { value: "DN", label: "DN - Del Norte" },
  { value: "ED", label: "ED - El Dorado" },
  { value: "Fre", label: "Fre - Fresno" },
  { value: "Gle", label: "Gle - Glenn" },
  { value: "Hum", label: "Hum - Humboldt" },
  { value: "Imp", label: "Imp - Imperial" },
  { value: "Iny", label: "Iny - Inyo" },
  { value: "Ker", label: "Ker - Kern" },
  { value: "Kin", label: "Kin - Kings" },
  { value: "Lak", label: "Lak - Lake" },
  { value: "Las", label: "Las - Lassen" },
  { value: "LA", label: "LA - Los Angeles" },
  { value: "Mad", label: "Mad - Madera" },
  { value: "Mrn", label: "Mrn - Marin" },
  { value: "Mpa", label: "Mpa - Mariposa" },
  { value: "Men", label: "Men - Mendocino" },
  { value: "Mer", label: "Mer - Merced" },
  { value: "Mod", label: "Mod - Modoc" },
  { value: "Mno", label: "Mno - Mono" },
  { value: "Mon", label: "Mon - Monterey" },
  { value: "Nap", label: "Nap - Napa" },
  { value: "Nev", label: "Nev - Nevada" },
  { value: "Ora", label: "Ora - Orange" },
  { value: "Pla", label: "Pla - Placer" },
  { value: "Plu", label: "Plu - Plumas" },
  { value: "Riv", label: "Riv - Riverside" },
  { value: "Sac", label: "Sac - Sacramento" },
  { value: "SBt", label: "SBt - San Benito" },
  { value: "SBd", label: "SBd - San Bernardino" },
  { value: "SD", label: "SD - San Diego" },
  { value: "SF", label: "SF - San Francisco" },
  { value: "SJ", label: "SJ - San Joaquin" },
  { value: "SLO", label: "SLO - San Luis Obispo" },
  { value: "SM", label: "SM - San Mateo" },
  { value: "SB", label: "SB - Santa Barbara" },
  { value: "SCl", label: "SCl - Santa Clara" },
  { value: "SCr", label: "SCr - Santa Cruz" },
  { value: "Sha", label: "Sha - Shasta" },
  { value: "Sie", label: "Sie - Sierra" },
  { value: "Sis", label: "Sis - Siskiyou" },
  { value: "Sol", label: "Sol - Solano" },
  { value: "Son", label: "Son - Sonoma" },
  { value: "Sta", label: "Sta - Stanislaus" },
  { value: "Sut", label: "Sut - Sutter" },
  { value: "Teh", label: "Teh - Tehama" },
  { value: "Tri", label: "Tri - Trinity" },
  { value: "Tul", label: "Tul - Tulare" },
  { value: "Tuo", label: "Tuo - Tuolumne" },
  { value: "Ven", label: "Ven - Ventura" },
  { value: "Yol", label: "Yol - Yolo" },
  { value: "Yub", label: "Yub - Yuba" },
];

export default ctCountyOptions;
